var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9121 18.3121L18.9802 9.26388C18.9417 8.88869 18.6257 8.60352 18.2486 8.60352H5.98775C5.6116 8.60352 5.29574 8.88773 5.25626 9.26193L4.29941 18.3146C4.22045 19.1047 4.48382 19.8986 5.0218 20.4933C5.55982 21.0875 6.32294 21.4286 7.11571 21.4286H17.1207C17.9098 21.4286 18.6658 21.0943 19.194 20.5109C19.7296 19.9207 19.9913 19.1203 19.9121 18.3121ZM18.1045 19.523C17.8505 19.803 17.5011 19.9572 17.1207 19.9572H7.11597C6.73809 19.9572 6.37247 19.7927 6.11279 19.5058C5.85309 19.2189 5.72585 18.8381 5.76312 18.4651L6.6498 10.0751H17.5847L18.4484 18.4598C18.4876 18.8577 18.3652 19.2353 18.1045 19.523Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2407 2.57141C9.91507 2.57141 8.02295 4.46349 8.02295 6.78913V9.33937H9.49425V6.78913C9.49425 5.27467 10.7262 4.0427 12.2407 4.0427C13.7551 4.0427 14.9873 5.27467 14.9873 6.78913V9.33937H16.4584V6.78913C16.4584 4.46349 14.5663 2.57141 12.2407 2.57141Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartWhite);
export default __webpack_public_path__ + "static/media/cartWhite.a349ead05497c4a8f9fc815ccdbd8e2f.svg";
export { ForwardRef as ReactComponent };